(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const headerRibbon = document.querySelector('.header__ribbon');
  const headerMain = document.querySelector('.header__main');
  const headerSpacer = document.querySelector('.header__main-spacer');

  function syncHeaderSpacer() {
    if (headerMain && headerSpacer) {
      const ribbonH = headerRibbon ? headerRibbon.offsetHeight : 0;
      headerSpacer.style.height = ribbonH + headerMain.offsetHeight + 'px';
    }
  }

  function updateHeaderTop() {
    if (!headerRibbon || !headerMain) return;
    const ribbonBottom = headerRibbon.getBoundingClientRect().bottom;
    headerMain.style.top = Math.max(0, ribbonBottom) + 'px';
  }

  syncHeaderSpacer();
  updateHeaderTop();
  window.addEventListener('scroll', updateHeaderTop, { passive: true });
  window.addEventListener('resize', () => {
    syncHeaderSpacer();
    updateHeaderTop();
  });

  const hamburger = document.querySelector('.header__hamburger');
  const menu = document.getElementById('header-mobile-menu');
  const closeBtn = menu?.querySelector('.header__mobile-menu-close');

  hamburger?.addEventListener('click', () => {
    menu.showModal();
    hamburger.setAttribute('aria-expanded', 'true');
  });

  closeBtn?.addEventListener('click', () => menu.close());

  menu?.addEventListener('click', (e) => {
    if (e.target === menu) menu.close();
  });

  menu?.addEventListener('close', () => {
    hamburger?.setAttribute('aria-expanded', 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-cta"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.home-cta').forEach(function (cta) {
    var id = cta.dataset.sectionId;
    if (!id) return;

    var arrowBtn = cta.querySelector('.home-cta__arrow-btn');
    var popup = cta.querySelector('#home-cta-popup-' + id);

    if (!arrowBtn || !popup) return;

    function positionPopup() {
      popup.style.left = '';
      popup.style.right = '';
      popup.style.maxWidth = '';
      var rect = popup.getBoundingClientRect();
      var parentRect = popup.parentElement.getBoundingClientRect();
      var margin = 8;

      if (rect.right > window.innerWidth - margin) {
        popup.style.left = 'auto';
        popup.style.right = '0';
        var newLeft = parentRect.right - rect.width;
        if (newLeft < margin) {
          popup.style.left = (margin - parentRect.left) + 'px';
          popup.style.right = 'auto';
          if (rect.width > window.innerWidth - 2 * margin) {
            popup.style.maxWidth = (window.innerWidth - 2 * margin) + 'px';
          }
        }
      } else if (rect.left < margin) {
        popup.style.left = '0';
        popup.style.right = 'auto';
        var newRight = parentRect.left + rect.width;
        if (newRight > window.innerWidth - margin) {
          popup.style.left = 'auto';
          popup.style.right = '0';
          var newerLeft = parentRect.right - rect.width;
          if (newerLeft < margin) {
            popup.style.left = (margin - parentRect.left) + 'px';
            popup.style.right = 'auto';
            if (rect.width > window.innerWidth - 2 * margin) {
              popup.style.maxWidth = (window.innerWidth - 2 * margin) + 'px';
            }
          }
        }
      }
    }

    function openPopup() {
      popup.hidden = false;
      positionPopup();
      arrowBtn.setAttribute('aria-expanded', 'true');
    }

    function closePopup() {
      popup.hidden = true;
      arrowBtn.setAttribute('aria-expanded', 'false');
    }

    arrowBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      popup.hidden ? openPopup() : closePopup();
    });

    document.addEventListener('click', function (e) {
      if (!popup.hidden && !popup.contains(e.target)) {
        closePopup();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) {
        closePopup();
        arrowBtn.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  (() => {
    const backButton = document.querySelector('[data-page-back]');

    if (!backButton) return;

    backButton.addEventListener('click', (event) => {
      const referrer = document.referrer;
      const homeUrl = backButton.dataset.homeUrl;
      let isInternalReferrer = false;

      if (referrer) {
        try {
          isInternalReferrer = new URL(referrer).origin === window.location.origin;
        } catch (error) {
          isInternalReferrer = false;
        }
      }

      if (isInternalReferrer && window.history.length > 1) {
        event.preventDefault();
        window.history.back();
        return;
      }

      backButton.setAttribute('href', homeUrl);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
